import es from "date-fns/locale/es";
import { useFormik } from "formik";
import moment from 'moment';
import { useCallback, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import DatePicker, { registerLocale } from 'react-datepicker';
import ReactNumeric from 'react-numeric';
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from "../../../../../_metronic/layout/core";
import { Loading } from "../../../../Components/Loading/Loading";
import Confirm from "../../../../Components/Modals/Confirm";
import Semaphore from '../../../../Components/Semaphore/Semaphore';
import AgTable from "../../../../Components/Table/AgTable";
import UploadZone from '../../../../Components/Upload/UploadZone';
import { useGetUser } from "../../../../Hooks/CustomHooks";
import { GetBancoListHabilitadosxCartaFianza, GetBancoListHabilitadosxOperacionEfectivo, GetDetalleGarantiaLocatario, GetMallList, GetMonedaList, SaveDetalleGarantia, UpdateEstadoDetalleGarantia, UploadAdjuntoDetalleGarantia, UploadAdjuntoDetalleGarantiaExcepcion, ValidationGarantiaLocatario } from "../../../../api/Api";
import { EXCEPCION_GARANTIA_ESTADO, EXCEPCION_GARANTIA_TIPO, GARANTIA_ESTADO, GARANTIA_TIPO } from "../../../Utils/Constants";
import ValidationGarantiaModal from "./components/validationGarantiaModal";
import "./guardarGarantiaLocatario.css";

export default function GuardarGarantiaLocatario() {
    const animatedComponents = makeAnimated();

    const [garantiaData, setGarantiaData] = useState({});
    registerLocale('es', es);
    const { id } = useParams();
    const [showModal, setShowModal] = useState(false)
    const [validationGarantiaData, setValidationGarantiaData] = useState(null)
    const [isAfterSave, setIsAfterSave] = useState(false);
    const user = useGetUser()

    const [guardadoExitoso, setGuardadoExitoso] = useState(false);
    const [urlAdjunto, setUrlAdjunto] = useState('');
    const [urlAdjuntoExcepcion, setUrlAdjuntoExcepcion] = useState('');
    const [isLoadingAdjunto, setIsLoadingAdjunto] = useState(false)
    const [disableFormInputs, setDisableFormInputs] = useState(false);
    const [showModalConfirm, setShowModalConfirm] = useState(false);
    const [isDisabledButton, setIsDisabledButton] = useState(false);
    const [isEnabledFormInputsExcepcion, setIsEnabledFormInputsExcepcion] = useState(false);

    const customDrop = acceptedFiles => {
        if (acceptedFiles.length === 0) {
            return;
        }
        setIsLoadingAdjunto(true);
        const formData = new FormData();
        formData.append('file', acceptedFiles[0]);

        UploadAdjuntoDetalleGarantia(formData, garantiaData.detalle_garantia.id_garantia_detalle)
            .then(response => {
                setUrlAdjunto(response.data.data.url)
            })
            .catch(error => console.error(error))
            .finally(() => {
                setIsLoadingAdjunto(false);
            });
    };

    const customDropExcepcion = acceptedFiles => {
        if (acceptedFiles.length === 0) {
            return;
        }
        setIsLoadingAdjunto(true);
        const formData = new FormData();
        formData.append('file', acceptedFiles[0]);

        UploadAdjuntoDetalleGarantiaExcepcion(formData, garantiaData.detalle_garantia.excepcion.id_garantia_excepcion, user.email)
            .then(response => {
                setUrlAdjuntoExcepcion(response.data.data.url)
            })
            .catch(error => console.error(error))
            .finally(() => {
                setIsLoadingAdjunto(false);
            });
    };


    const {
        data: initDataGarantiaLocatarioQuery,
        isFetching: isFetchingInitDataGarantiaLocatario,
        refetch: refetchGarantiaLocatarioQuery
    } = useQuery(["initDataGarantiaLocatario", id], async ({ queryKey }) => {
        try {
            const id = queryKey[1];
            let codigoEstado = null;
            let codigoEstadoExcepcion = null;
            let result = null;
            result = await GetDetalleGarantiaLocatario(id);
            codigoEstado = result.data.detalle_garantia.estado.codigo;
            codigoEstadoExcepcion = result.data.detalle_garantia.excepcion.codigo_estado_excepcion;


            setGarantiaData(result.data);


            //TODO: Bifurcar por Tipo Garantia
            if (result.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
                setUrlAdjunto(result.data.detalle_garantia.url_filename_carta_fianza);
            } else if (result.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO) {
                setUrlAdjunto(result.data.detalle_garantia.url_filename_operacion);
            }

            if (codigoEstado === GARANTIA_ESTADO.EN_REVISION
                || codigoEstado === GARANTIA_ESTADO.EN_REQUERIMIENTO_RENOVACION
                || codigoEstado === GARANTIA_ESTADO.APROBADO) {
                setDisableFormInputs(true);
                setIsDisabledButton(true);
            }


            if ((codigoEstado === GARANTIA_ESTADO.INGRESADO || codigoEstado === GARANTIA_ESTADO.PENDIENTE || codigoEstado === GARANTIA_ESTADO.RECHAZADO)
                && (codigoEstadoExcepcion === EXCEPCION_GARANTIA_ESTADO.APROBADO.CODE && result.data.detalle_garantia.is_excepcion)) {
                setIsEnabledFormInputsExcepcion(true);
                setIsDisabledButton(false);
                setDisableFormInputs(true);
            } else {
                setIsEnabledFormInputsExcepcion(false);
            }


            
            const monedaList = await GetMonedaList();
            const mallList = await GetMallList();
            let bancoList = null;
            const tipoCartaFianzaList = [
                {
                  "id_tipo_carta_fianza": 383,
                  "descripcion_tipo_carta_fianza": "Primera"
                },
                {
                  "id_tipo_carta_fianza": 384,
                  "descripcion_tipo_carta_fianza": "Renovación"
                }
              ];
            

            if (result.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
                bancoList = await GetBancoListHabilitadosxCartaFianza();
            } else if (result.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO) {
                bancoList = await GetBancoListHabilitadosxOperacionEfectivo();
            }

            

            const formatSelectMonedaList = transformOption(monedaList.data, "id_moneda", "codigo");
            const formatSelectMallList = transformOption(mallList.data, "id_mall", "nombre");
            const formatSelectBancoList = transformOption(bancoList.data, "id_banco", "codigo");

            const formatSelectTipoCartaFianzaList  = transformOption(tipoCartaFianzaList, "id_tipo_carta_fianza", "descripcion_tipo_carta_fianza");

            setFormikFieldValueCartaFianza("ruc", result.data.garantia.ruc);
            setFormikFieldValueCartaFianza("razonSocial", result.data.garantia.razon_social);
            setFormikFieldValueCartaFianza("nombreComercial", result.data.garantia.nombre_comercial ?? "");
            setFormikFieldValueCartaFianza("mall", getDefaultOption(result.data.garantia.mall.id_mall, formatSelectMallList));
            setFormikFieldValueCartaFianza("banco", getDefaultOption(result.data.detalle_garantia.banco.id_banco, formatSelectBancoList));
            setFormikFieldValueCartaFianza("moneda", getDefaultOption(result.data.garantia.moneda.id_moneda, formatSelectMonedaList));
            setFormikFieldValueCartaFianza("nroCartaFianza", result.data.detalle_garantia.nro_carta_fianza ?? "");
            setFormikFieldValueCartaFianza("nroOperacion", result.data.detalle_garantia.nro_operacion ?? "");
            setFormikFieldValueCartaFianza("startDate", result.data.detalle_garantia.fecha_emision_carta_fianza ? new Date(result.data.detalle_garantia.fecha_emision_carta_fianza) : null);
            setFormikFieldValueCartaFianza("endDate", result.data.detalle_garantia.fecha_vencimiento_carta_fianza ? new Date(result.data.detalle_garantia.fecha_vencimiento_carta_fianza) : null);
            setFormikFieldValueCartaFianza("importe", result.data.detalle_garantia.importe);

            setFormikFieldValueCartaFianza("tipoCartaFianza", getDefaultOption(result.data.detalle_garantia.id_tipo_carta_fianza, formatSelectTipoCartaFianzaList));
            

            let bancoExcepcionList = null;
            if (result.data.detalle_garantia.excepcion.codigo_estado_excepcion === EXCEPCION_GARANTIA_ESTADO.APROBADO.CODE &&
                result.data.detalle_garantia.is_excepcion) {
                if (result.data.detalle_garantia.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.CARTA_FIANZA_A_EFECTIVO) {
                    const bancoRes = await GetBancoListHabilitadosxOperacionEfectivo();
                    bancoExcepcionList = transformOption(bancoRes.data, "id_banco", "codigo")
                    setUrlAdjuntoExcepcion(result.data.detalle_garantia.excepcion.url_file_name_efectivo);
                    setFormikFieldValueCartaFianza("excepcionNroOperacion", result.data.detalle_garantia.excepcion.nro_operacion_efectivo ?? "");
                    setFormikFieldValueCartaFianza("excepcionFechaDeposito", result.data.detalle_garantia.excepcion.fecha_deposito_efectivo ? new Date(result.data.detalle_garantia.excepcion.fecha_deposito_efectivo) : null);
                    setFormikFieldValueCartaFianza("excepcionBanco", result.data.detalle_garantia.excepcion.id_banco_efectivo ? getDefaultOption(result.data.detalle_garantia.excepcion.id_banco_efectivo, bancoExcepcionList) : null);
                } else {
                    const bancoRes = await GetBancoListHabilitadosxCartaFianza();
                    bancoExcepcionList = transformOption(bancoRes.data, "id_banco", "codigo")

                    setUrlAdjuntoExcepcion(result.data.detalle_garantia.excepcion.url_file_name_carta_fianza);
                    setFormikFieldValueCartaFianza("excepcionNroCartaFianza", result.data.detalle_garantia.excepcion.nro_carta_fianza ?? "");
                    setFormikFieldValueCartaFianza("excepcionStartDate", result.data.detalle_garantia.excepcion.fecha_emision_carta_fianza ? new Date(result.data.detalle_garantia.excepcion.fecha_emision_carta_fianza) : null);
                    setFormikFieldValueCartaFianza("excepcionEndDate", result.data.detalle_garantia.excepcion.fecha_vencimiento_carta_fianza ? new Date(result.data.detalle_garantia.excepcion.fecha_vencimiento_carta_fianza) : null);
                    // setFormikFieldValueCartaFianza("excepcionBanco", getDefaultOption(result.data.detalle_garantia.excepcion.id_banco_carta_fianza, bancoExcepcionList));
                    setFormikFieldValueCartaFianza("excepcionBanco", result.data.detalle_garantia.excepcion.id_banco_carta_fianza ? getDefaultOption(result.data.detalle_garantia.excepcion.id_banco_carta_fianza, bancoExcepcionList) : null);
                }
            }

            return {
                garantia: result.data.garantia,
                detalleGarantia: result.data.detalle_garantia,
                monedaList: formatSelectMonedaList,
                mallList: formatSelectMallList,
                bancoList: formatSelectBancoList,
                tipoCartaFianzaList: formatSelectTipoCartaFianzaList,
                bancoExcepcionList: bancoExcepcionList,
                revisiones: result.data.revisiones,
            };
        } catch (error) {
            console.log(error);
        }
    }, {
        enabled: !!id
    });

    const transformOption = useCallback((array, valueKey, labelKey) => {
        return array.map(item => ({
            value: item[valueKey],
            label: item[labelKey]
        }));
    }, []);

    const getDefaultOption = useCallback((defaultValue, list) => {
        if (defaultValue && list.length > 0) {
            const item = list.find(item => item.value === defaultValue);
            return { value: item.value, label: item.label }
        } else {
            return { value: "", label: "" }
        }
    }, [])

    const {
        mutate: mutateUpdateEstadoDetalleGarantia,
        isLoading: isLoadingUpdateEstadoDetalleGarantia,
    } = useMutation("updateEstadoDetalleGarantia", UpdateEstadoDetalleGarantia, {
        onSuccess: (res) => {
            setGuardadoExitoso(true);
            setDisableFormInputs(true);
            refetchGarantiaLocatarioQuery();
        },
        onError: (err) => {
            console.log(err.message);
        },
    });

    const {
        mutate: mutateSendRevision,
        isLoading: isLoadingSendRevision,
    } = useMutation("sendRevisionGarantiaLocatario", ValidationGarantiaLocatario, {
        onSuccess: (res) => {
            setValidationGarantiaData(res.data);
            if (res.data.success) {
                const obj = {
                    id_detalle_garantia: initDataGarantiaLocatarioQuery.detalleGarantia.id_garantia_detalle,
                    codigo_estado_detalle_garantia: GARANTIA_ESTADO.EN_REVISION,
                    updated_by: user.email
                }
                mutateUpdateEstadoDetalleGarantia(obj);
            } else {
                setShowModal(true);
            }
        },
        onError: (err) => {
            console.log(err.message);
        },
    });

    const {
        mutate: mutateValidationGarantiaLocatario,
        isLoading: isLoadingValidationGarantiaLocatario,
    } = useMutation("validationGarantiaLocatario", ValidationGarantiaLocatario, {
        onSuccess: (res) => {
            setIsAfterSave(true);
            setShowModal(true);
            setValidationGarantiaData(res.data);
            refetchGarantiaLocatarioQuery();
        },
        onError: (err) => {
            console.log(err.message);
        },
    });

    const {
        mutate: mutateSaveDetalleGarantia,
        isLoading: isLoadingSaveDetalleGarantia,
    } = useMutation("saveDetalleGarantia", SaveDetalleGarantia, {
        onSuccess: (res) => {
            if (res?.data?.success) {
                mutateValidationGarantiaLocatario({
                    id_garantia_detalle: initDataGarantiaLocatarioQuery.detalleGarantia.id_garantia_detalle,
                    rol_revisor: user.role.id,
                    usuario_revisor: user.email
                })
            }
        },
        onError: (err) => {
            console.log(err.message);
        },
    });


    const customColumnDef = {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 10,
        //defaultMinWidth: 50,
        floatingFilter: true,
        // allow every column to be grouped
        enableRowGroup: false
    };

    const header = useMemo(() => [
        {
            headerName: '',
            filter: false,
            width: 60,
            cellRenderer: (props) => (
                <div className="align-items-center d-flex h-100 justify-content-center">
                    <Semaphore
                        caption=''
                        size={'25px'}
                        fontSize={'11px'}
                        tooltipTitle={props.data.nombre_rol_revisor}
                        lastUpdateDate={props.data.fecha_revision}
                        lastUpdatedBy={props.data.usuario_revisor}
                        tooltipDescription={props.data.observaciones}
                        color={props.data.semaforo_color}>
                    </Semaphore>
                    {/* <Semaphore caption="LO" size={'25px'} fontSize={'11px'} color={props.data.semaforo_color}></Semaphore> */}
                </div>
            )
        },
        {
            headerName: 'Rol',
            field: 'nombre_rol_revisor',
            flex: 1,

        },
        {
            flex: 1,
            headerName: 'Usuario',
            field: 'usuario_revisor',
        },
        {
            headerName: 'Fecha',
            width: 150,
            field: 'fecha_revision',
            valueFormatter: (params) => {
                return moment(params.value).format("DD/MM/yyyy HH:mm");
            }
        },

    ], [])


    const { values: formikValuesCartaFianza,
        setFieldValue: setFormikFieldValueCartaFianza,
        handleSubmit: handleSubmitFormikCartaFianza,
    } = useFormik({
        initialValues: {
            ruc: "",
            razonSocial: "",
            nombreComercial: "",
            mall: null,
            banco: null,
            moneda: null,
            nroCartaFianza: "",
            nroOperacion: "",
            startDate: null,
            endDate: null,
            importe: "",
            tipoCartaFianza: null,
            excepcionNroOperacion: "",
            excepcionFechaDeposito: null,
            excepcionNroCartaFianza: "",
            excepcionStartDate: null,
            excepcionEndDate: null,
            excepcionBanco: null,
        },
        enableReinitialize: true,
        onSubmit: (values) => {

            let obj = {
                "id_garantia_detalle": initDataGarantiaLocatarioQuery.detalleGarantia.id_garantia_detalle,
                "razon_social": values.razonSocial,
                "nombre_comercial": values.nombreComercial,
                "id_banco": values.banco.value,
                "importe": values.importe ? values.importe : null,
                "nro_carta_fianza": values.nroCartaFianza ? values.nroCartaFianza : null,
                "nro_operacion": values.nroOperacion ? values.nroOperacion : null,
                "fecha_emision_carta_fianza": moment(values.startDate).toISOString(),
                "fecha_vencimiento_carta_fianza": moment(values.endDate).toISOString(),
                "updated_by": user.email,
                "excepcion": null,
                "id_tipo_carta_fianza": values.tipoCartaFianza.value
            }


            if (initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.codigo_estado_excepcion === EXCEPCION_GARANTIA_ESTADO.APROBADO.CODE &&
                initDataGarantiaLocatarioQuery?.detalleGarantia.is_excepcion) {
                obj.excepcion = {
                    "codigo_tipo_excepcion": initDataGarantiaLocatarioQuery.detalleGarantia.excepcion.codigo_tipo_excepcion,
                    "codigo_tipo_garantia_excepcion": initDataGarantiaLocatarioQuery.detalleGarantia.excepcion.codigo_tipo_garantia_excepcion,
                    "id_banco_efectivo": null,
                    "id_banco_carta_fianza": null,
                    "nro_operacion_efectivo": values.excepcionNroOperacion ? values.excepcionNroOperacion : null,
                    "fecha_deposito_efectivo": values.excepcionFechaDeposito,
                    "nro_carta_fianza": values.excepcionNroCartaFianza ? values.excepcionNroCartaFianza : null,
                    "fecha_emision_carta_fianza": values.excepcionStartDate,
                    "fecha_vencimiento_carta_fianza": values.excepcionEndDate,
                    "id_tipo_carta_fianza": null
                }
                if (initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.CARTA_FIANZA_A_EFECTIVO) {
                    obj.excepcion.id_banco_efectivo = values.excepcionBanco?.value ?? null;
                } else {
                    obj.excepcion.id_banco_carta_fianza = values.excepcionBanco?.value ?? null;
                }
            }

            mutateSaveDetalleGarantia(obj);
        }
    })

    const handleShowRevisionModal = useCallback((event) => {
        setShowModalConfirm(true);
    }, [])

    const onConfirmEnviarRevision = useCallback(() => {
        mutateSendRevision({
            id_garantia_detalle: initDataGarantiaLocatarioQuery.detalleGarantia.id_garantia_detalle,
            rol_revisor: user.role.id,
            usuario_revisor: user.email
        })
    }, [
        initDataGarantiaLocatarioQuery,
        mutateSendRevision,
        user
    ])


    function validateDatePlaceHolder() {
        if (garantiaData.fecha_emision_carta_fianza && garantiaData.fecha_vencimiento_carta_fianza) {
            return "Selecciona un rango de fechas";
        }
    }


    function guardadoExistosoModal() {
        setGuardadoExitoso(false);
    }

    const validateNumberInput = (event) => {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            event.preventDefault();
        }
    }

    const showLoading = useCallback(() => {
        return (
            isFetchingInitDataGarantiaLocatario ||
            isLoadingSaveDetalleGarantia ||
            isLoadingValidationGarantiaLocatario ||
            isLoadingSendRevision ||
            isLoadingUpdateEstadoDetalleGarantia
        )
    }, [
        isFetchingInitDataGarantiaLocatario,
        isLoadingSaveDetalleGarantia,
        isLoadingValidationGarantiaLocatario,
        isLoadingSendRevision,
        isLoadingUpdateEstadoDetalleGarantia
    ])


    return (
        <>
            <PageTitle>
                Actualizar Garant&iacute;a
            </PageTitle>
            <div className="row mt-2 mb-2 max-width-1080">
                <div className="col-12 col-md w-md-100 d-flex justify-content-center">
                    <Semaphore
                        caption='LO'
                        size={'40px'}
                        fontSize={'16px'}
                        tooltipTitle={"Revisión de Locatario"}
                        lastUpdateDate={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_locatario?.fecha_revision}
                        lastUpdatedBy={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_locatario?.usuario_revisor}
                        tooltipDescription={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_locatario?.observaciones}
                        color={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_locatario?.semaforo_color}>
                    </Semaphore>
                    <Semaphore
                        caption='CO'
                        size={'40px'}
                        fontSize={'16px'}
                        tooltipTitle={"Revisión de Cobranza"}
                        lastUpdateDate={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_cobranza?.fecha_revision}
                        lastUpdatedBy={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_cobranza?.usuario_revisor}
                        tooltipDescription={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_cobranza?.observaciones}
                        color={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_cobranza?.semaforo_color}>
                    </Semaphore>
                    {((initDataGarantiaLocatarioQuery?.detalleGarantia?.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA && !initDataGarantiaLocatarioQuery?.detalleGarantia?.is_excepcion)
                        || (initDataGarantiaLocatarioQuery?.detalleGarantia?.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO
                            && initDataGarantiaLocatarioQuery?.detalleGarantia?.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.EFECTIVO_A_CARTA_FIANZA)) ?
                        (
                            <Semaphore
                                caption='TE'
                                size={'40px'}
                                fontSize={'16px'}
                                tooltipTitle={"Revisión de Tesorería"}
                                lastUpdateDate={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_tesoreria?.fecha_revision}
                                lastUpdatedBy={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_tesoreria?.usuario_revisor}
                                tooltipDescription={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_tesoreria?.observaciones}
                                color={initDataGarantiaLocatarioQuery?.detalleGarantia?.revision_tesoreria?.semaforo_color}>
                            </Semaphore>
                        ) : null
                    }
                </div>
            </div>
            <div className="row mt-2 mb-2 max-width-1080">
                <div className="col-12 col-md w-md-100 d-flex justify-content-center">
                    <span className='badge badge-pill badge-secondary badge-text-small ms-3'>{initDataGarantiaLocatarioQuery?.detalleGarantia?.estado?.nombre}</span>
                    {
                        initDataGarantiaLocatarioQuery?.detalleGarantia?.is_excepcion
                            && initDataGarantiaLocatarioQuery?.detalleGarantia?.excepcion.codigo_estado_excepcion === EXCEPCION_GARANTIA_ESTADO.APROBADO.CODE ? (
                            <span className='badge badge-pill badge-danger badge-text-small ms-3'>Con Excepción: {initDataGarantiaLocatarioQuery?.detalleGarantia?.excepcion?.nombre_tipo_excepcion}</span>
                        ) : null
                    }
                </div>
            </div>
            <hr className="opacity-5" />
            <div className="row my-5">
                <div className="col-12 d-flex align-items-center">
                    <button
                        type="button"
                        className="btn btn-primary me-2 btn-sm"
                        disabled={isDisabledButton || showLoading()}
                        onClick={handleSubmitFormikCartaFianza}>
                        <i className="fi fi-rr-disk fs-3"></i> Guardar
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        disabled={isDisabledButton || showLoading()}
                        onClick={handleShowRevisionModal} >
                        <i className="fi fi-rr-paper-plane fs-3"></i> Enviar a Revisi&oacute;n
                    </button>
                    {showLoading() ? (
                        <div className="inline-block ms-3">
                            <Loading></Loading>
                        </div>
                    ) : null}

                </div>
            </div>

            <Accordion defaultActiveKey={['0']} alwaysOpen className="position-relative max-width-1080">
                {showLoading() ? (
                    <div className="confirmWithLoader-overlay">
                    </div>
                ) : null}

                <Accordion.Item eventKey="0">
                    <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Datos Generales</span></Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-12 mb-4 mb-sm-6 d-flex align-items-center justify-content-end">
                                <label className="fs-5 fw-bold">Nro Contrato</label>
                                <span className="ms-6">{initDataGarantiaLocatarioQuery?.garantia.nro_contrato}</span>
                            </div>
                            <div className="col-12">
                                <div className="row mb-6 align-items-center">
                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                        <label className="fs-5 fw-bold">Ruc</label>
                                    </div>
                                    <div className="col-12 col-sm w-sm-100">
                                        <input
                                            className="form-control form-control-solid"
                                            value={formikValuesCartaFianza.ruc}
                                            disabled={disableFormInputs}
                                            onChange={(e) => setFormikFieldValueCartaFianza("ruc", e.target.value)}
                                            onKeyPress={validateNumberInput}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-6 align-items-center">
                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                        <label className="fs-5 fw-bold ">Razon Social</label>
                                    </div>
                                    <div className="col-12 col-sm w-sm-100">
                                        <input
                                            className="form-control form-control-solid"
                                            value={formikValuesCartaFianza.razonSocial}
                                            disabled={disableFormInputs}
                                            onChange={(e) => setFormikFieldValueCartaFianza("razonSocial", e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-6 align-items-center">
                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                        <label className="fs-5 fw-bold ">Nombre Comercial</label>
                                    </div>
                                    <div className="col-12 col-sm w-sm-100">
                                        <input
                                            className="form-control form-control-solid"
                                            value={formikValuesCartaFianza.nombreComercial}
                                            disabled={disableFormInputs}
                                            onChange={(e) => setFormikFieldValueCartaFianza("nombreComercial", e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-6 align-items-center">
                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                        <label className="fs-5 fw-bold ">Mall</label>
                                    </div>
                                    <div className="col-12 col-sm w-sm-100">
                                        <Select classNamePrefix='filter'
                                            components={animatedComponents}
                                            value={formikValuesCartaFianza.mall}
                                            isMulti={false}
                                            closeMenuOnSelect={true}
                                            options={initDataGarantiaLocatarioQuery?.mallList}
                                            placeholder="Selecciona"
                                            isDisabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>
                        {initDataGarantiaLocatarioQuery?.detalleGarantia?.tipo_garantia?.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA
                            && <><i className="fi fi-rr-file-invoice-dollar fs-3 me-2"></i><span className="fs-4">Carta Fianza</span></>
                        }

                        {initDataGarantiaLocatarioQuery?.detalleGarantia?.tipo_garantia?.codigo === GARANTIA_TIPO.GAR0_EFECTIVO
                            && <><i className="fi fi-rr-file-invoice-dollar fs-3 me-2"></i><span className="fs-4">Operación en Efectivo</span></>
                        }
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-12">
                                <div className="row mb-6 align-items-center">
                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                        <label className="fs-5 fw-bold ">Banco</label>
                                    </div>
                                    <div className="col-12 col-sm w-sm-100">
                                        <Select classNamePrefix='filter'
                                            components={animatedComponents}
                                            value={formikValuesCartaFianza.banco}
                                            isMulti={false}
                                            closeMenuOnSelect={true}
                                            options={initDataGarantiaLocatarioQuery?.bancoList}
                                            placeholder="Selecciona"
                                            isDisabled={disableFormInputs}
                                            onChange={(e) => setFormikFieldValueCartaFianza("banco", e)}
                                            isSearchable={false}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-6 align-items-center">
                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                        <label className="fs-5 fw-bold ">Moneda</label>
                                    </div>
                                    <div className="col-12 col-sm w-sm-100">
                                        <Select classNamePrefix='filter'
                                            components={animatedComponents}
                                            value={formikValuesCartaFianza.moneda}
                                            isMulti={false}
                                            closeMenuOnSelect={true}
                                            options={initDataGarantiaLocatarioQuery?.monedaList}
                                            placeholder="Selecciona"
                                            isDisabled={true}
                                        />
                                    </div>
                                </div>
                                {initDataGarantiaLocatarioQuery?.detalleGarantia?.tipo_garantia?.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA ? (
                                    <div className="row mb-6 align-items-center">
                                        <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                            <label className="fs-5 fw-bold ">Nro Carta Fianza</label>
                                        </div>
                                        <div className="col-12 col-sm w-sm-100">
                                            <input
                                                className="form-control form-control-solid"
                                                value={formikValuesCartaFianza.nroCartaFianza}
                                                disabled={disableFormInputs}
                                                onChange={(e) => setFormikFieldValueCartaFianza("nroCartaFianza", e.target.value)}
                                            // onKeyPress={validateNumberInput}
                                            />
                                        </div>
                                    </div>
                                ) : initDataGarantiaLocatarioQuery?.detalleGarantia?.tipo_garantia?.codigo === GARANTIA_TIPO.GAR0_EFECTIVO ? (
                                    <div className="row mb-6 align-items-center">
                                        <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                            <label className="fs-5 fw-bold ">Nro Operaci&oacute;n</label>
                                        </div>
                                        <div className="col-12 col-sm w-sm-100">
                                            <input
                                                className="form-control form-control-solid"
                                                value={formikValuesCartaFianza.nroOperacion}
                                                disabled={disableFormInputs}
                                                onChange={(e) => setFormikFieldValueCartaFianza("nroOperacion", e.target.value)}
                                                onKeyPress={validateNumberInput}
                                            />
                                        </div>
                                    </div>
                                ) : null}
                                {initDataGarantiaLocatarioQuery?.detalleGarantia?.tipo_garantia?.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA &&
                                    <div className="row mb-6 align-items-center">
                                        <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                            <label className="fs-5 fw-bold ">Vigencia</label>
                                        </div>
                                        <div className="col-12 col-sm-5 col-md-4 col-lg-5 col-xl-4 col-xxl-3">
                                            <DatePicker
                                                className="form-control form-control-solid pe-5"
                                                selectsRange={true}
                                                locale="es"
                                                startDate={formikValuesCartaFianza.startDate}
                                                endDate={formikValuesCartaFianza.endDate}
                                                dateFormat="dd/MM/yyyy"
                                                shouldCloseOnSelect={false}
                                                onChange={(dateRange) => {
                                                    setFormikFieldValueCartaFianza("startDate", dateRange[0]);
                                                    setFormikFieldValueCartaFianza("endDate", dateRange[1]);
                                                }}
                                                placeholderText={validateDatePlaceHolder()}
                                                showMonthDropdown={true}
                                                showYearDropdown={true}
                                                dropdownMode="select"
                                                disabled={disableFormInputs}
                                            />
                                        </div>
                                    </div>
                                }
                                <div className="row mb-6 align-items-center">
                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                        <label className="fs-5 fw-bold ">Importe</label>
                                    </div>
                                    <div className="col-12 col-sm w-sm-100">
                                        <ReactNumeric
                                            className="form-control form-control-solid"
                                            value={formikValuesCartaFianza.importe}
                                            decimalCharacter="."
                                            digitGroupSeparator=","
                                            disabled={disableFormInputs}
                                            onChange={(e, value) => setFormikFieldValueCartaFianza("importe", parseFloat(value || 0))}
                                        />
                                    </div>
                                </div>
                                {/* @JD */}
                                <div className="row mb-6 align-items-center">
                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                        <label className="fs-5 fw-bold ">Tipo Carta Fianza</label>
                                    </div>
                                    <div className="col-12 col-sm w-sm-100">
                                        <Select classNamePrefix='filter'
                                            components={animatedComponents}
                                            value={formikValuesCartaFianza.tipoCartaFianza}
                                            isMulti={false}
                                            closeMenuOnSelect={true}
                                            options={initDataGarantiaLocatarioQuery?.tipoCartaFianzaList}
                                            placeholder="Selecciona"
                                            isDisabled={disableFormInputs}
                                            onChange={(e) => setFormikFieldValueCartaFianza("tipoCartaFianza", e)}
                                            isSearchable={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <Accordion.Header><i className="fi fi-rr-clip fs-3 me-2"></i><span className="fs-4">Adjunto</span></Accordion.Header>
                    <Accordion.Body>
                        <div className='row'>
                            <UploadZone
                                onDrop={customDrop}
                                fileUrl={urlAdjunto}
                                isLoading={isLoadingAdjunto}
                                isDisabled={disableFormInputs}>
                            </UploadZone>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
                {initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.codigo_estado_excepcion === EXCEPCION_GARANTIA_ESTADO.APROBADO.CODE &&
                    initDataGarantiaLocatarioQuery?.detalleGarantia.is_excepcion ? (
                    <>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header><i className="fi fi-rr-replace fs-3 me-2"></i><span className="fs-4">Datos de la Excepción</span></Accordion.Header>
                            <Accordion.Body>
                                <div className="row ">
                                    <div className="col-12 col-xl-6">
                                        <div className="row mb-6 align-items-center">
                                            <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                <label className="fs-5 fw-bold ">Tipo Excepción</label>
                                            </div>
                                            <div className="col-12 col-sm w-sm-100">
                                                <input
                                                    className="form-control form-control-solid"
                                                    value={initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.nombre_tipo_excepcion}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-6">
                                        <div className="row mb-6 align-items-center">
                                            <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                <label className="fs-5 fw-bold ">Fecha de Venc.</label>
                                            </div>
                                            <div className="col-12 col-sm w-sm-100">
                                                <input
                                                    className="form-control form-control-solid"
                                                    value={initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.fecha_vencimiento && `${moment(initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.fecha_vencimiento).format("DD/MM/yyyy")}`}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-6">
                                        <div className="row mb-6 align-items-center">
                                            <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                <label className="fs-5 fw-bold ">Importe</label>
                                            </div>
                                            <div className="col-12 col-sm w-sm-100">
                                                <input
                                                    className="form-control form-control-solid"
                                                    value={initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.importe}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-6">
                                        <div className="row mb-6 align-items-center">
                                            <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                <label className="fs-5 fw-bold ">Moneda</label>
                                            </div>
                                            <div className="col-12 col-sm w-sm-100">
                                                <input
                                                    className="form-control form-control-solid"
                                                    value={initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.codigo_moneda}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-6">
                                        <div className="row mb-6 align-items-center">
                                            <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                <label className="fs-5 fw-bold ">Sustento</label>
                                            </div>
                                            <div className="col-12 col-sm w-sm-100">
                                                <div className='col-12 col-sm w-sm-100'>
                                                    <a href={initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.url_file_name_adjunto} target='_blank' rel='noreferrer' className='ms-6'>
                                                        <i className="fi fi-rr-download fs-4"></i> {initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.file_name_adjunto}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-6">
                                        <div className="row mb-6 align-items-center">
                                            <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                <label className="fs-5 fw-bold ">Motivo</label>
                                            </div>
                                            <div className="col-12 col-sm w-sm-100">
                                                <textarea
                                                    className="form-control form-control-solid"
                                                    value={initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.motivo}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {initDataGarantiaLocatarioQuery?.detalleGarantia.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.CARTA_FIANZA_A_EFECTIVO ? (
                                        <>
                                            <div className="col-12 col-xl-6">
                                                <div className="row mb-6 align-items-center">
                                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                        <label className="fs-5 fw-bold ">Nro Operaci&oacute;n</label>
                                                    </div>
                                                    <div className="col-12 col-sm w-sm-100">
                                                        <input
                                                            className="form-control form-control-solid"
                                                            value={formikValuesCartaFianza?.excepcionNroOperacion}
                                                            onChange={(e) => setFormikFieldValueCartaFianza("excepcionNroOperacion", e.target.value)}
                                                            onKeyPress={validateNumberInput}
                                                            disabled={!isEnabledFormInputsExcepcion}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-6">
                                                <div className="row mb-6 align-items-center">
                                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                        <label className="fs-5 fw-bold ">Fecha Depósito</label>
                                                    </div>
                                                    <div className="col-12 col-sm w-sm-100">
                                                        <DatePicker
                                                            className="form-control form-control-solid pe-5 text-start"
                                                            selectsRange={false}
                                                            locale="es"
                                                            selected={formikValuesCartaFianza.excepcionFechaDeposito}
                                                            dateFormat="dd/MM/yyyy"
                                                            shouldCloseOnSelect={false}
                                                            onChange={(e) => setFormikFieldValueCartaFianza("excepcionFechaDeposito", e)}
                                                            placeholderText={"Selecciona una fecha"}
                                                            showMonthDropdown={true}
                                                            showYearDropdown={true}
                                                            dropdownMode="select"
                                                            disabled={!isEnabledFormInputsExcepcion}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="col-12 col-xl-6">
                                                <div className="row mb-6 align-items-center">
                                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                        <label className="fs-5 fw-bold ">Nro Carta Fianza</label>
                                                    </div>
                                                    <div className="col-12 col-sm w-sm-100">
                                                        <input
                                                            className="form-control form-control-solid"
                                                            value={formikValuesCartaFianza.excepcionNroCartaFianza}
                                                            onChange={(e) => setFormikFieldValueCartaFianza("excepcionNroCartaFianza", e.target.value)}
                                                            // onKeyPress={validateNumberInput}
                                                            disabled={!isEnabledFormInputsExcepcion}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-6">
                                                <div className="row mb-6 align-items-center">
                                                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                        <label className="fs-5 fw-bold ">Vigencia</label>
                                                    </div>
                                                    <div className="col-sm w-sm-100">
                                                        <DatePicker
                                                            className="form-control form-control-solid pe-5 text-start"
                                                            selectsRange={true}
                                                            locale="es"
                                                            startDate={formikValuesCartaFianza.excepcionStartDate}
                                                            endDate={formikValuesCartaFianza.excepcionEndDate}
                                                            dateFormat="dd/MM/yyyy"
                                                            shouldCloseOnSelect={false}
                                                            onChange={(dateRange) => {
                                                                setFormikFieldValueCartaFianza("excepcionStartDate", dateRange[0]);
                                                                setFormikFieldValueCartaFianza("excepcionEndDate", dateRange[1]);
                                                            }}
                                                            placeholderText={validateDatePlaceHolder()}
                                                            showMonthDropdown={true}
                                                            showYearDropdown={true}
                                                            dropdownMode="select"
                                                            disabled={!isEnabledFormInputsExcepcion}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <div className="col-12 col-xl-6">
                                        <div className="row mb-6 align-items-center">
                                            <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                                                <label className="fs-5 fw-bold ">Banco</label>
                                            </div>
                                            <div className="col-12 col-sm w-sm-100">
                                                <Select classNamePrefix='filter'
                                                    components={animatedComponents}
                                                    isMulti={false}
                                                    closeMenuOnSelect={true}
                                                    value={formikValuesCartaFianza.excepcionBanco}
                                                    options={initDataGarantiaLocatarioQuery?.bancoExcepcionList}
                                                    placeholder="Selecciona"
                                                    onChange={(e) => setFormikFieldValueCartaFianza("excepcionBanco", e)}
                                                    isSearchable={false}
                                                    isDisabled={!isEnabledFormInputsExcepcion}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4">
                            <Accordion.Header><i className="fi fi-rr-clip fs-3 me-2"></i><span className="fs-4">Adjunto de la Excepción</span></Accordion.Header>
                            <Accordion.Body>
                                <div className='row'>
                                    <UploadZone
                                        onDrop={customDropExcepcion}
                                        fileUrl={urlAdjuntoExcepcion}
                                        isLoading={isLoadingAdjunto}
                                        isDisabled={!isEnabledFormInputsExcepcion}>
                                    </UploadZone>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </>
                ) : null}


                <Accordion.Item eventKey="5">
                    <Accordion.Header><i className="fi fi-rr-time-past fs-3 me-2"></i><span className="fs-4">Historial de Revisiones</span></Accordion.Header>
                    <Accordion.Body>
                        <AgTable idContent={"HistorialRevisiones"}
                            setAuxData={null}
                            header={header}
                            titleExcel={"Historial de Revisiones"}
                            conditions={true}
                            hideFilter={true}
                            paginationPageSize={8}
                            rowHeight={40}
                            localData={initDataGarantiaLocatarioQuery?.revisiones}
                            customDefaultColDef={customColumnDef}
                        />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion >

            {
                validationGarantiaData &&
                <ValidationGarantiaModal
                    key={"validationGarantiaModal"}
                    showModal={showModal && !isFetchingInitDataGarantiaLocatario}
                    setShowModal={setShowModal}
                    isAfterSave={isAfterSave}
                    success={validationGarantiaData?.success}
                    validationList={validationGarantiaData?.validationMessages}
                />
            }
            <Modal
                size="sm"
                show={guardadoExitoso && !isFetchingInitDataGarantiaLocatario}
                onHide={() => setGuardadoExitoso(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                        Guardado Exitoso
                    </Modal.Title>
                </Modal.Header>
                <Modal.Footer style={{ margin: 'auto' }}>
                    <button type="button" className="btn btn-primary" onClick={guardadoExistosoModal}>
                        Aceptar
                    </button>
                </Modal.Footer>
            </Modal>
            <Confirm
                key={"confirmValidationGarantia"}
                showModal={showModalConfirm}
                setShowModal={setShowModalConfirm}
                onConfirm={onConfirmEnviarRevision}
                message={'Seguro que desea <b><u>confirmar</u></b> el envío de la Garantía a revisión?'}
            >
            </Confirm>
        </>
    )
}